

import AoneService from "../axiosbase";
//get pickup request
export const getPickupRequest = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/pickup/request${params}`);
    } catch (error) {
      return error;
    }
  };
  //PR Version 2
  export const getPickupRequestV2 = async (params) => {
    try {
      return await AoneService.post(`ops/api/v2/pickup/request/filter`, params);
    } catch (error) {
      return error;
    }
  };
//get pickup request by id
export const getPickupRequestbyId = async (params) => {
  try {
    return await AoneService.get(`ops/api/v1/pickup/request/${params}`);
  } catch (error) {
    return error;
  }
};
//post pickup request
export const postPickupRequest = async (data) => {
    try {
      return await AoneService.post("ops/api/v1/pickup/request", data);
    } catch (error) {
      return error;
    }
  };
//edit pickup request
export const editPickupRequest = async (params,data) => {
    try {
      return await AoneService.put(`ops/api/v1/pickup/request/${params}`, data);
    } catch (error) {
      return error;
    }
  };
//upload pickup request
export const importPickupRequests = async (data) => {
    try {
      return await AoneService.post(`ops/api/v1/pickup/request/upload`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  //upload proof
  export const importPickupRequestsProof = async (param,data) => {
    try {
      return await AoneService.post(`ops/api/v1/pickup/request/${param}/images/201`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  //upload proof for consignments
    //upload proof
    export const importConsignmentDeliveryProof = async (params,data) => {
      try {
        return await AoneService.post(`ops/api/v1/consignments/images/604?trackingIdList=${params}`,data, {
          "Content-Type": "multipart/form-data",
        });
      } catch (error) {
        return error;
      }
    };
     export const importConsignmentPickupProof = async (params,data) => {
      try {
        return await AoneService.post(`ops/api/v1/consignments/images/204?trackingIdList=${params}`,data, {
          "Content-Type": "multipart/form-data",
        });
      } catch (error) {
        return error;
      }
    };
    export const importConsignmentSignatureProof = async (params,data) => {
      try {
        return await AoneService.post(
          `ops/api/v1/consignments/${params}/image/604?fileType=SIGNATURE_IMAGE`,
          data,
          {
            "Content-Type": "multipart/form-data",
          });
      } catch (error) {
        return error;
      }
    };
//pickup request template
  export const getPickupTemplate = async () => {
    try {
      return await AoneService.get(
        "ops/api/v1/pickup/request/template",
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
//export pickup request
export const exportPickupRequests = async (params) => {
    try {
      return await AoneService.post("ops/api/v1/pickup/request/export" , params, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //export all pickup request
  export const exportAllPickupRequests = async (params) => {
    try {
      return await AoneService.post("ops/api/v1/pickup/request/export-all" , params, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//cancel pickup request
export const cancelPickupRequest = async (params,data) => {
    try {
      return await AoneService.post(`ops/api/v1/pickup/request/${params}/cancel`, data);
    } catch (error) {
      return error;
    }
  };
  //pickup failed
  export const failedPickupRequest = async (data) => {
    try {
      return await AoneService.post(`ops/api/v1/pickup/request/submit-failed`, data);
    } catch (error) {
      return error;
    }
  };
//apply pickup request
export const applyPickupRequest = async (params,data) => {
    try {
      return await AoneService.post(`ops/api/v1/pickup/request/${params}/apply`, data);
    } catch (error) {
      return error;
    }
  };
  //apply bulk pickup request
  export const applyBulkPickupRequest = async (data) => {
    try {
      return await AoneService.patch("ops/api/v1/pickup/request/assign", data);
    } catch (error) {
      return error;
    }
  };
  //assign supplier to pickup request
export const assignSupplierPickupRequest = async (data) => {
    try {
      return await AoneService.patch("ops/api/v1/pickup/request/assign-supplier", data);
    } catch (error) {
      return error;
    }
  };
  //assign station
  export const assignStationPickupRequest = async (data) => {
    try {
      return await AoneService.patch("ops/api/v1/pickup/request/assign-station", data);
    } catch (error) {
      return error;
    }
  };
//get packagelevel event
export const getPackageTrackEvent = async (param) => {
  try {
    return await AoneService.post(`ops/api/v1/events/package/${param}`);
  } catch (error) {
    return error;
  }
};
  
//post consignment by pickup request
export const postPickupConsignment = async (params,data) => {
    try {
      return await AoneService.post(`ops/api/v1/pickup/request/${params}/consignments`, data);
    } catch (error) {
      return error;
    }
  };
//delete consignment
export const deletePickupConsignment = async (params,params2) => {
    try {
      return await AoneService.delete(`ops/api/v1/pickup/request/${params}/consignments/${params2}`);
    } catch (error) {
      return error;
    }
  };

  //consignment controller
  export const getConsignments = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/consignments${params}`);
    } catch (error) {
      return error;
    }
  };
//**********consignments post method--version 1.1 **********
export const postConsignments = async (data) => {
  try {
    return await AoneService.post(`ops/api/v1.1/consignments`,data);
  } catch (error) {
    return error;
  }
};
//version 3
export const postConsignmentsV3 = async (data) => {
  try {
    return await AoneService.post(`ops/api/v3/consignments`,data);
  } catch (error) {
    return error;
  }
};
  //consignment destination info
  export const getConsignmentsDestination = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/consignments/${params}/destination`);
    } catch (error) {
      return error;
    }
  };
//apply pickup consignments
export const applyConsignments = async (data)=>{
   try{
    return await AoneService.post(`ops/api/v1/scans`,data);
   } catch (error) {
    return error;
   }
}
//bulk apply
export const bulkapplyConsignments = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/bulk`,data);
  } catch (error) {
   return error;
  }
}
export const bulkapplyInScanConsignments = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v2/scans/compact-bulk`,data);
  } catch (error) {
   return error;
  }
}
//scan rto delivery
export const bulkapplyRtoConsignments = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/rto-delivered`,data);
  } catch (error) {
   return error;
  }
}
//rto ofd
export const bulkOfdRtoConsignments = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/rto-ofd`,data);
  } catch (error) {
   return error;
  }
}
//receive supplier
//revoke pickup consignment
export const receiveSupplierBulk = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/receive`,data);
  } catch (error) {
   return error;
  }
}
//revoke pickup consignment
export const revokePickupConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-pickup`,data);
  } catch (error) {
   return error;
  }
}
//revoke cancel consignment
export const revokeCancelConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-cancel`,data);
  } catch (error) {
   return error;
  }
}
//revoke lost
export const revokeConsignmentLost = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-lost`,data);
  } catch (error) {
   return error;
  }
}
//revoke damage
export const revokeConsignmentDamage = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-damage`,data);
  } catch (error) {
   return error;
  }
}
//revoke disposed
export const revokeConsignmentDisposed = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-disposed`,data);
  } catch (error) {
   return error;
  }
}
//revoke delivery consignment
export const revokeDeliveryConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-delivery`,data);
  } catch (error) {
   return error;
  }
}
//revoke hold
export const revokeHoldConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/consignments/revoke-hold`,data);
  } catch (error) {
   return error;
  }
}
export const revokeSettleConsignment = async (data)=>{
  try{
   return await AoneService.post(`collections/api/v1/collections/revoke-settled`,data);
  } catch (error) {
   return error;
  }
}
export const applyOfdConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/ofd`,data);
  } catch (error) {
   return error;
  }
}
//apply delivery
export const applyDeliveryConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/delivered`,data);
  } catch (error) {
   return error;
  }
}
//apply delivery failed
export const applyDeliveryFailedConsignment = async (data)=>{
  try{
   return await AoneService.post(`ops/api/v1/scans/delivery-failed`,data);
  } catch (error) {
   return error;
  }
}
//ddu update template
export const dduUpdateTemplate = async () => {
  try {
    return await AoneService.get(
      `orders/api/v1/consignments/ddu/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//upload ddu
export const importDdu = async (data) => {
  try {
    return await AoneService.post(`orders/api/v1/consignments/ddu/upload`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
  //get pickup request consignment
  export const getPickupConsignments = async (params,data) => {
    try {
      return await AoneService.get(`ops/api/v1/pickup/request/${params}/consignments${data}`);
    } catch (error) {
      return error;
    }
  };

  //consignment export
  export const exportConsignments = async (params) => {
    try {
      return await AoneService.get("ops/api/v1/consignments/export" + params, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//**********consignments export post method--version 1.1 **********
export const exportConsignmentsbyPost = async (data) => {
  try {
    return await AoneService.post("ops/api/v1.1/consignments/export" , data, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
  //consignment lookups
  export const getConsignmentStatus = async () => {
    try {
      return await AoneService.get(`ops/api/v1/lookups/PickupRequestStatus`);
    } catch (error) {
      return error;
    }
  };
  //pickuprequest lookups
  export const getPickuprequestStatus = async () => {
    try {
      return await AoneService.get(`ops/api/v1/lookups/EventCode`);
    } catch (error) {
      return error;
    }
  };
  //print pickup request
export const printPickupRequests = async (params) => {
  try {
    return await AoneService.get(`ops/api/v1/pickup/request/${params}/print?url=false`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//pickup reschedule date update
export const postPickupScheduleDate = async (data) => {
  try {
    return await AoneService.put(`ops/api/v1/consignments/pickup-scheduled-date`,data);
  } catch (error) {
    return error;
  }
};
//delivery reschedule date update
export const postDeliveryScheduleDate = async (data) => {
  try {
    return await AoneService.put(`ops/api/v1/consignments/delivery-scheduled-date`,data);
  } catch (error) {
    return error;
  }
};
//pickup request-reschedule
export const postPickupReschedule = async (params,data) => {
  try {
    return await AoneService.patch(`ops/api/v1/pickup/request/${params}/schedule-date`,data);
  } catch (error) {
    return error;
  }
};
//single api for Suppliers
export const postSingleSupplier = async (data) => {
  try {
    return await AoneService.post(`ops/api/v1/scans/supplier`,data);
  } catch (error) {
    return error;
  }
};
//bulk action for suppliers
export const postBulkSupplier = async (data) => {
  try {
    return await AoneService.post(`ops/api/v1/scans/supplier-bulk`,data);
  } catch (error) {
    return error;
  }
};

//packages
//get packages
export const getPackages = async (params) => {
  try {
    return await AoneService.get(`ops/api/v1/package${params}`);
  } catch (error) {
    return error;
  }
};
//export
  //consignment export
  export const exportPackages = async (params) => {
    try {
      return await AoneService.get("ops/api/v1/package/export" + params, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
// Reassign Pickup Request
export const reassignPickupRequest = async (data) => {
  try {
    return await AoneService.patch(`ops/api/v1/pickup/request/reassign`, data);
  } catch (error) {
    return error;
  }
};

// Unassign Pickup Request
export const unassignPickupRequest = async (data) => {
  try {
    return await AoneService.patch(`ops/api/v1/pickup/request/unassign`, data);
  } catch (error) {
    return error;
  }
};

// Cancel waybills from pickup requests (non-RPU only)
export const cancelPickupWaybills = async (data) => {
  try {
    return await AoneService.post(
      `ops/api/v1/pickup/request/consignment/cancel`,
      data
    );
  } catch (error) {
    return error;
  }
};